package views.componentes

import androidx.compose.runtime.NoLiveLiterals

@NoLiveLiterals
class ffAudio {
    // Função externa para tocar o beep
    fun ffPlayBeep(_tipo: Boolean) {
        val audioContext = js("new (window.AudioContext || window.webkitAudioContext)()")
        val oscillator = audioContext.createOscillator()
        oscillator.type = "square"
        if (_tipo)
            oscillator.frequency.setValueAtTime(440.0, audioContext.currentTime) // Frequência do beep (440 Hz)
        else
            oscillator.frequency.setValueAtTime(220.0, audioContext.currentTime) // Frequência do beep (440 Hz)

        oscillator.connect(audioContext.destination)
        oscillator.start()
        if (_tipo)
            oscillator.stop(audioContext.currentTime + 0.1) // Duração do beep (0.1 segundos)
        else
            oscillator.stop(audioContext.currentTime + 0.2) // Duração do beep de falha (0.2 segundos)
    }
}
